import { motion } from "framer-motion";
import { Plane, ScanLine, Radio, Camera, Satellite } from "lucide-react";

const equipment = [
  { icon: Plane, name: "DJI Matrice 350 RTK", note: "Enterprise flagship platform" },
  { icon: ScanLine, name: "Zenmuse L2 LiDAR", note: "Integrated LiDAR + RGB payload" },
  { icon: Radio, name: "Enterprise RTK Drone", note: "Centimetre-level positioning" },
  { icon: Camera, name: "DSLR Cameras", note: "Ground & interior documentation" },
  { icon: Satellite, name: "RTK GNSS Equipment", note: "Ground control & base stations" },
];

export const Equipment = () => {
  return (
    <section id="equipment" className="py-24 bg-[#f8f9fa] border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-[#8b8f99]">Our Equipment</span>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-black text-[#10193f]">
            Enterprise-grade drone & survey fleet
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {equipment.map((e, i) => {
            const Icon = e.icon;
            return (
              <motion.div
                key={e.name}
                data-testid={`equipment-${i}`}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.06 }}
                className="rounded-sm border border-gray-200 bg-white p-6 hover:border-[#10193f]/40 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-sm bg-[#10193f] text-white">
                  <Icon className="h-6 w-6" strokeWidth={1.6} />
                </div>
                <h3 className="mt-5 font-heading text-base font-bold text-[#10193f]">{e.name}</h3>
                <p className="mt-1 text-sm text-[#52525b]">{e.note}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
